/* DOMNO. — MYSTERY 7 add-on for the 7-piece bundle builder (v2).  v14 · 15 Oct 2026.
   v14: FULL FUNNEL TRACKING for the Intelligems test (both arms) + waits up to 8 s for the
   test flag (the Intelligems script is deferred, so the flag can land after this file runs).
   Control sets window.DOMNO_MYSTERY = false, the Mystery arm sets it true. Every step goes to
   Intelligems (igEvents, identifiers domnoM7*), Clarity (event + session tag m7 = control /
   mystery) and dataLayer (m7_<step>). The cart also gets _bundle_mode = mystery / bestsellers /
   shuffle / own (+ -edited if they changed pieces after a preset), so orders in Shopify show
   how each bundle was built in BOTH arms. ?dp_track=1 logs to the console instead of sending.
   v4-v13 history: see harness-v13.js in Projects/7 Piece Bundle CRO.
   ===========================================================================
   Why this file: layout/theme.liquid already loads assets/domno-bundle-harness.js on
   every page (it was an empty retired QA file), so the Mystery option ships as this
   ONE asset without touching the 62KB builder section.

   The flow Dom picked (14 Oct): Shuffle becomes MYSTERY (NEW). Tap it -> the 7 slots turn
   into black "?" boxes and the Add to cart button is right there and ready. Tap Add to
   cart -> a pop-up asks for ring size (a second size if wanted) and Silver / Gold / Mix,
   with its own Add to cart. We pick the 7 after the order: 2 rings, 1 chain, 2 pendants,
   2 bracelets - the same shape as the normal bundle. "?" and MYSTERY are set in
   Montserrat Black Italic.

   OFF unless:  ?dp=mystery  (preview, remembered for the tab; ?dp=off clears it)
           or:  window.DOMNO_MYSTERY === true  (set by the Intelligems test variant)
   When off it returns on the first lines and nothing on the page changes.

   PREVIEW BUILD: the pop-up's Add to cart shows a note and writes nothing to the cart yet.
   The builder's own code is never edited; this listens in the capture phase and only
   steps in while Mystery is the selected option.
   =========================================================================== */
(function () {
  'use strict';

  /* ---------- switch ---------- */
  var preview = false;
  try {
    if (/[?&]dp=off\b/.test(location.search)) sessionStorage.removeItem('dp_mystery');
    if (/[?&]dp=mystery\b/.test(location.search)) sessionStorage.setItem('dp_mystery', '1');
    preview = sessionStorage.getItem('dp_mystery') === '1';
  } catch (e) {}
  var MYSTERY_VARIANT = 57655316676981;
  var MKEY = 'domno_mystery', LSKEY = 'jewellery-bundle_bundleItems';
  var TEST = /[?&]dp_track=1\b/.test(location.search), ARM = 'none', SENT = {};
  var BMKEY = 'domno_bmode';
  var ON_ADDON = location.pathname.indexOf('7-piece-jewellery-bundle-addon') > -1;
  var ON_BUNDLE = !ON_ADDON && /\/products\/jewellery-bundle\/?$/.test(location.pathname);
  if (!ON_ADDON && !ON_BUNDLE) return;

  /* ---------- tracking ---------- */
  function ev(id) {
    if (SENT[id]) return; SENT[id] = 1;                      // each step once per page view
    if (TEST || (preview && !TEST)) { (window.__m7 = window.__m7 || []).push(id); try { console.log('[m7]', ARM, id); } catch (e) {} return; }
    try { window.igEvents = window.igEvents || []; window.igEvents.push({ event: id }); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', id); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'm7_' + id.replace(/^domnoM7/, ''), m7_arm: ARM }); } catch (e) {}
  }
  function saveMode(mode) { try { localStorage.setItem(BMKEY, JSON.stringify({ mode: mode, ts: Date.now() })); } catch (e) {} }
  var BM = { last: 'own', edited: false };
  function modeNow() { return BM.last + (BM.edited && BM.last !== 'own' ? '-edited' : ''); }
  function trackBundlePage() {
    ev('domnoM7Seen');
    try { if (typeof window.clarity === 'function' && ARM !== 'none' && !preview) window.clarity('set', 'm7', ARM); } catch (e) {}
    // window + capture runs before the Mystery handler (document capture), so every tap is seen
    window.addEventListener('click', function (e) {
      var t = e.target; if (!t.closest) return;
      var p = t.closest('#bbld #presets .preset');
      if (p) {
        var key = p.getAttribute('data-preset');
        if (S.active && key !== 'mystery') ev('domnoM7LeftMystery');
        if (key === 'mystery') ev('domnoM7TapMystery');
        else if (key === 'shuffle') { ev('domnoM7TapShuffle'); BM.last = 'shuffle'; BM.edited = false; }
        else if (key === 'bestsellers') { ev('domnoM7TapBest'); BM.last = 'bestsellers'; BM.edited = false; }
        else if (key === 'scratch') { ev('domnoM7TapOwn'); BM.last = 'own'; BM.edited = false; }
        return;
      }
      if (t.closest('#bbld .confirm, #bbld #altgrid .aadd')) { BM.edited = true; ev('domnoM7PutPiece'); return; }
      if (t.closest('#bbld [data-my="go"]')) { ev('domnoM7Card'); return; }
      var a = t.closest('#bbld #addBtn');
      if (a) {
        if (S.active) { ev('domnoM7PopFromCta'); return; }
        if (a.classList.contains('incomplete')) { ev('domnoM7AddIncomplete'); return; }
        ev('domnoM7AddBundle');
        ev({ bestsellers: 'domnoM7AddBest', shuffle: 'domnoM7AddShuffle', own: 'domnoM7AddOwn' }[BM.last] || 'domnoM7AddOwn');
        if (BM.edited && BM.last !== 'own') ev('domnoM7AddEdited');
        saveMode(modeNow());
      }
    }, true);
  }

  /* ---------- state ---------- */
  var KIND = ['ring', 'ring', 'ring', 'ring', 'bracelet', 'pendant', 'earring'];   // the mystery box shape (Dom, 15 Oct)
  var S = { active: false, size: null, extra: [], two: false, metal: 'silver', tried: false };

  function $(id) { return document.getElementById(id); }
  function lc(x) { return ('' + (x == null ? '' : x)).toLowerCase(); }

  /* ---------- catalogue (the same JSON the builder reads) ---------- */
  var CAT = [];
  function loadCat() {
    try { CAT = JSON.parse(($('dpCatalogue') || {}).textContent || '[]') || []; } catch (e) { CAT = []; }
  }
  function sizeKey(p) {
    var n = (p.onames || []).map(lc), idx = -1;
    n.forEach(function (x, i) { if (idx < 0 && (x.indexOf('size') > -1 || x.indexOf('length') > -1)) idx = i; });
    return idx < 0 ? null : 'o' + (idx + 1);
  }
  function metalKey(p) {
    for (var i = 0; i < (p.onames || []).length; i++) {
      var k = 'o' + (i + 1);
      if ((p.variants || []).some(function (v) { var l = lc(v[k]); return l.indexOf('gold') > -1 || l.indexOf('silver') > -1; })) return k;
    }
    return null;
  }
  function inStock(p) { return (p.variants || []).some(function (v) { return v.a; }); }
  function baseKey(t) { return lc(t).split(' ').slice(0, 2).join(' '); }
  // Same rule as the builder's own Best Sellers: first in-stock piece of each kind in
  // catalogue order (which is best-seller order), never two of the same design.
  function bestSeven() {
    var out = [], used = {};
    KIND.forEach(function (c) {
      var p = CAT.filter(function (q) { return q.cat === c && inStock(q) && out.indexOf(q) < 0 && !used[baseKey(q.title)]; })[0];
      if (p) { out.push(p); used[baseKey(p.title)] = 1; }
    });
    return out;
  }
  function priceOf(p, gold) {
    var mk = metalKey(p), c = (p.variants || []).filter(function (v) { return v.a; });
    if (!c.length) c = p.variants || [];
    if (mk) { var want = c.filter(function (v) { return (lc(v[mk]).indexOf('gold') > -1) === !!gold; }); if (want.length) c = want; }
    return c[0] ? (+c[0].pr || 0) : 0;
  }
  function ringSizes() {
    var count = {};
    CAT.forEach(function (p) {
      if (p.cat !== 'ring') return; var k = sizeKey(p); if (!k) return; var seen = {};
      (p.variants || []).forEach(function (v) { var x = v[k]; if (v.a && x && /^\d+(\.\d+)?$/.test('' + x) && !seen[x]) { seen[x] = 1; count[x] = (count[x] || 0) + 1; } });
    });
    var out = Object.keys(count).filter(function (k) { return count[k] >= 3; }).sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    return out.length >= 4 ? out : ['5', '6', '7', '8', '9', '10', '11', '12'];
  }

  /* ---------- money: read the builder's own figures so every market is right ---------- */
  var PRICE_TXT = '', PER_TXT = '', CUR = null, PRICE_NUM = 0;
  function readPrices() {
    var fp = $('footPrice'), sa = $('saveAmt');
    PRICE_TXT = fp ? fp.textContent.trim() : '';
    PER_TXT = sa ? sa.textContent.trim() : '';
    PRICE_NUM = parseFloat(PRICE_TXT.replace(/[^\d.,]/g, '').replace(/,(?=\d{3}\b)/g, '').replace(',', '.')) || 0;
    try { CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || null; } catch (e) {}
  }
  function fmt(cents) {
    var n = cents / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: CUR || 'GBP', minimumFractionDigits: (cents % 100 ? 2 : 0), maximumFractionDigits: (cents % 100 ? 2 : 0) }).format(n); }
    catch (e) { return '£' + Math.round(n); }
  }
  function worthCents() {
    var g = S.metal === 'gold';
    return bestSeven().reduce(function (t, p) { return t + priceOf(p, g); }, 0);
  }

  /* ---------- CSS ---------- */
  var MONT = "'Montserrat',Inter,-apple-system,sans-serif";
  var CSS = '' +
    /* the Mystery button: red, sweeping light, a Montserrat "?", and a NEW tag that pulses */
    '#bbld .preset[data-preset="mystery"]{position:relative;background:#d0021b;border-color:#d0021b;color:#fff;font-weight:800;letter-spacing:.06em;box-shadow:0 3px 10px rgba(208,2,27,.35)}' +
    '#bbld .preset[data-preset="mystery"].active{background:#111;border-color:#111;box-shadow:none}' +
    '#bbld .preset .my-shine{position:absolute;inset:0;overflow:hidden;pointer-events:none}' +
    '#bbld .preset .my-shine:after{content:"";position:absolute;top:0;bottom:0;left:-60%;width:45%;background:linear-gradient(100deg,rgba(255,255,255,0) 0%,rgba(255,255,255,.55) 50%,rgba(255,255,255,0) 100%);transform:skewX(-18deg);animation:myshine 3.2s ease-in-out infinite}' +
    '@keyframes myshine{0%,55%{left:-60%}85%,100%{left:130%}}' +
    '#bbld .preset .my-lbl{position:relative;z-index:1}' +
    '#bbld .preset .my-qm{font-family:' + MONT + ';font-weight:900;font-style:italic;font-size:15px;letter-spacing:-0.3px;line-height:0;margin-right:5px;position:relative;top:1px}' +
    '#bbld .preset .my-new{display:inline-block;position:relative;z-index:2;vertical-align:middle;margin-left:6px;top:-1px;background:#fff;color:#d0021b;font-family:Inter,-apple-system,sans-serif;font-size:8px;font-weight:800;font-style:normal;letter-spacing:.08em;padding:3px 4px 3px 5px;line-height:1;animation:mynew 1.8s ease-in-out infinite}' +
    '#bbld .preset[data-preset="mystery"].active .my-new{background:#d0021b;color:#fff}' +
    '@keyframes mynew{0%,100%{transform:scale(1)}50%{transform:scale(1.14)}}' +
    '@media (prefers-reduced-motion:reduce){#bbld .preset .my-shine:after,#bbld .preset .my-new{animation:none}}' +
    '#bbld.myston #stack{display:none!important}' +
    '#bbld.myston .sheet,#bbld.myston .backdrop{display:none!important}' +
    '#bbld #myst{display:none}#bbld.myston #myst{display:block}' +
    '#bbld .my-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;padding:0 8px 14px}' +
    '#bbld .my-t .my-img{aspect-ratio:4/5;position:relative;overflow:hidden;background:#111;color:#fff;text-transform:uppercase}' +
    '#bbld .my-t .my-img:before{content:"";position:absolute;inset:0;background:url(https://cdn.shopify.com/s/files/1/0305/7100/4043/files/7pc.jpg?v=1792058093&width=400) center/cover no-repeat;opacity:.18;pointer-events:none}' +
    '#bbld .my-q,#bbld .my-l1,#bbld .my-l2{z-index:1}' +
    '#bbld .my-q{position:absolute;left:0;right:0;top:50%;transform:translateY(-54%);text-align:center;font-family:' + MONT + ';font-weight:900;font-style:italic;font-size:54px;letter-spacing:-0.3px;line-height:1}' +
    '#bbld .my-l1,#bbld .my-l2{position:absolute;font-family:Inter,-apple-system,sans-serif;font-style:normal;font-weight:800;letter-spacing:.1em;line-height:1.15}' +
    /* Sealed: a red tape band across the corner saying PICKED BY US */
    '#bbld .my-l2{top:13px;right:-30px;width:120px;transform:rotate(38deg);background:#d0021b;color:#fff;text-align:center;font-size:7px;padding:4px 0}' +
    '#bbld .my-l1{bottom:10px;left:0;right:0;text-align:center;font-size:8.5px}' +
    '#bbld .my-card{grid-column:span 2;aspect-ratio:auto;background:#d0021b;color:#fff;display:flex;flex-direction:column;justify-content:center;padding:16px 18px;cursor:pointer;text-transform:none}' +
    '#bbld .my-card b{display:block;font-family:' + MONT + ';font-weight:900;font-style:italic;font-size:22px;letter-spacing:-0.3px;line-height:1.05;text-transform:uppercase}' +
    '#bbld .my-card span{display:block;font-size:12px;line-height:1.45;margin-top:8px;color:#ffe3e6;text-transform:none;letter-spacing:0}' +
    '#bbld .my-card u{display:inline-block;align-self:flex-start;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;margin-top:12px;text-decoration:none;border-bottom:2px solid #fff;padding-bottom:2px}' +
    /* Desktop (1200px+) normally shows no top buttons and splits catalogue | rail. While Mystery
       is on, fold back to one centred column so it reads like the phone version. */
    '@media (min-width:1200px){#bbld.myston{display:block!important;left:auto!important;right:auto!important;width:auto!important;max-width:640px!important;margin:0 auto!important}' +
    '#bbld.myston .rail{position:static!important;min-height:0!important;max-height:none!important;overflow:visible!important;background:#fff!important;border:0!important}' +
    '#bbld.myston .presets{display:flex!important;padding:16px 10px 2px}#bbld.myston .yb-head .lbl span{display:inline}}' +
    /* the pop-up */
    '.my-popbk{position:fixed;inset:0;z-index:100004;overscroll-behavior:contain;touch-action:none;background:rgba(0,0,0,.5);display:none;align-items:flex-end;justify-content:center;font-family:Inter,-apple-system,sans-serif;color:#111;text-align:left;text-transform:none;letter-spacing:normal}' +
    '.my-popbk.on{display:flex}' +
    '.my-popbk *{box-sizing:border-box;border-radius:0}' +
    '.my-pop{width:100%;max-width:640px;background:#fff;border-top:2px solid #111;padding:18px 0 calc(14px + env(safe-area-inset-bottom));max-height:90vh;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;touch-action:pan-y}' +
    '.my-pophd{display:flex;justify-content:space-between;align-items:flex-start;padding:0 14px 4px}' +
    '.my-pophd b{font-family:' + MONT + ';font-weight:900;font-style:italic;font-size:22px;text-transform:uppercase;letter-spacing:-0.3px;line-height:1.1}' +
    '.my-pophd span{font-size:28px;line-height:.7;cursor:pointer;padding:0 2px}' +
    '.my-popsub{padding:0 14px 16px;font-size:12px;line-height:1.5;color:#555}' +
    '.my-popbody{padding:0 14px}' +
    '.my-ph{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;margin-bottom:9px;display:flex;justify-content:space-between;align-items:baseline}' +
    '.my-ph button{background:none;border:none;font-family:inherit;font-size:10.5px;font-weight:600;color:#111;text-decoration:underline;letter-spacing:.05em;text-transform:uppercase;cursor:pointer;padding:0}' +
    '.my-row{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:10px}' +
    '.my-chip{font-family:inherit;font-size:14px;min-width:42px;text-align:center;padding:11px 11px;border:1px solid #ccc;background:#fff;color:#111;font-weight:600;cursor:pointer}' +
    '.my-chip.on{background:#111;color:#fff;border-color:#111}' +
    '.my-chip.off{opacity:.3;cursor:default}' +
    '.my-guide{align-self:center;margin-left:6px;background:none;border:none;font-family:inherit;font-size:10.5px;font-weight:600;color:#111;text-decoration:underline;letter-spacing:.05em;text-transform:uppercase;cursor:pointer;padding:6px 0}' +
    '.my-cnt{font-weight:600;color:#888;letter-spacing:.04em}' +
    '.my-chip.gold.on{background:linear-gradient(135deg,#f4d27a,#c99a2e);color:#2e2100;border-color:#c99a2e}' +
    '.my-chip.wide{flex:1 1 0;text-transform:uppercase;font-size:12px;letter-spacing:.04em}' +
    '.my-more{background:none;border:none;font-family:inherit;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.05em;text-decoration:underline;margin:2px 0 18px;padding:0;cursor:pointer;color:#111}' +
    '.my-sub{font-size:10.5px;color:#888;margin:-2px 0 8px;text-transform:uppercase;letter-spacing:.05em;font-weight:600}' +
    '.my-err{font-size:11.5px;color:#d0021b;font-weight:600;margin:-2px 0 12px}' +
    '.my-popfoot{border-top:1px solid #eee;margin-top:6px;padding:12px 14px 0}' +
    '.my-popfoot .p{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:10px}' +
    '.my-popfoot s{color:#999;font-size:15px;font-weight:500}' +
    '.my-popfoot b{font-size:22px;font-weight:700;margin-left:9px;color:#d0021b}' +
    '.my-popfoot .pp{font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:.03em}' +
    '.my-buy{display:block;width:100%;background:#111;color:#fff;border:none;padding:17px;font-family:inherit;font-size:13.5px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;cursor:pointer}' +
    '.my-buy.dis{background:#bbb}';

  /* ---------- markup ---------- */
  var SIZES = [], wrap = null, pop = null, lbl = null, lblOrig = '';
  function chips(isOn, attr, tail, isOff) {
    return '<div class="my-row">' + SIZES.map(function (s) {
      var off = isOff && isOff(s);
      return '<button type="button" class="my-chip' + (isOn(s) ? ' on' : '') + (off ? ' off' : '') + '" data-' + attr + '="' + s + '"' + (off ? ' disabled' : '') + '>' + s + '</button>';
    }).join('') + (tail || '') + '</div>';
  }
  function ready() { return !!S.size && (!S.two || S.extra.length > 0); }
  function pickers() {
    var h = '<div class="my-ph">Ring size</div>';
    h += chips(function (s) { return s === S.size; }, 'sz', '<button type="button" class="my-guide" data-my="guide">Don\'t know your size?</button>');
    if (S.tried && !S.size) h += '<div class="my-err">Pick a ring size so they fit.</div>';
    if (S.two) {
      h += '<div class="my-ph">What other sizes do you want? <span class="my-cnt">' + S.extra.length + '/3</span></div>' +
        chips(function (s) { return S.extra.indexOf(s) > -1; }, 'sz2', '', function (s) { return s === S.size; });
      if (S.tried && S.size && !S.extra.length) h += '<div class="my-err">Pick at least one other size, or tap Just one size.</div>';
      h += '<button type="button" class="my-more" data-my="one">Just one size</button>';
    } else {
      h += '<button type="button" class="my-more" data-my="two">+ Want a range of sizes?</button>';
    }
    h += '<div class="my-ph">Metal</div><div class="my-row">' +
      [['silver', 'Silver'], ['gold', 'Gold'], ['mix', 'Mix']].map(function (m) {
        return '<button type="button" class="my-chip wide' + (m[0] === 'gold' ? ' gold' : '') + (S.metal === m[0] ? ' on' : '') + '" data-mt="' + m[0] + '">' + m[1] + '</button>';
      }).join('') + '</div>';
    return h;
  }
  function popFoot() {
    var w = worthCents(), showW = PRICE_NUM && w / 100 > PRICE_NUM;
    return '<div class="p"><span>' + (showW ? '<s>' + fmt(w) + '</s>' : '') + '<b>' + PRICE_TXT + '</b></span><span class="pp">' + PER_TXT + '</span></div>' +
      '<button type="button" class="my-buy' + (ready() ? '' : ' dis') + '" data-my="buy">' +
      (ready() ? 'Add to cart — ' + PRICE_TXT : (S.size ? 'Choose your other sizes' : 'Choose a ring size')) + '</button>';
  }
  /* final copy (Dom, 14 Oct). [card title, card line, card link, pop-up title, pop-up line] */
  var C = ['Leave it to us', '7 mystery pieces, chosen by us.', 'Surprise me', 'Ready to be surprised?', 'Pick your ring size and metal. We\'ll pick the 7.'];
  function tiles() {
    var c = C;
    return '<div class="my-grid">' + KIND.map(function () {
      return '<div class="my-t"><div class="my-img"><div class="my-q">?</div><i class="my-l1">Mystery item</i><i class="my-l2">Picked by us</i></div></div>';
    }).join('') +
      '<div class="my-card" data-my="go"><b>' + c[0] + '</b><span>' + c[1] + '</span><u>' + c[2] + '</u></div></div>';
  }

  function renderPop() {
    if (!pop) return;
    pop.querySelector('.my-popbody').innerHTML = pickers();
    pop.querySelector('.my-popfoot').innerHTML = popFoot();
  }
  function price() {
    var w = worthCents(), fw = $('footWorth'), fp = $('footPrice'), sa = $('saveAmt'), cn = $('cntNum'), btn = $('addBtn');
    if (fw) fw.textContent = (PRICE_NUM && w / 100 > PRICE_NUM) ? fmt(w) : '';
    if (fp) fp.textContent = PRICE_TXT;
    if (sa) sa.textContent = PER_TXT;
    if (cn) cn.textContent = '7';
    if (btn) { btn.classList.remove('incomplete'); btn.textContent = 'Add mystery bundle to cart — ' + PRICE_TXT; }
  }
  var toastT;
  function toast(m) { var t = $('toast'); if (!t) return; t.textContent = m; t.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 1800); }
  /* Lock the page behind the pop-up. overflow:hidden alone is ignored by iOS Safari, so the body
     is pinned in place (position:fixed at the current scroll) and put back where it was on close. */
  var lockY = 0, locked = false;
  function lock(on) {
    var b = document.body, h = document.documentElement;
    if (on && !locked) {
      lockY = window.pageYOffset || h.scrollTop || 0; locked = true;
      h.style.overflow = 'hidden'; b.style.overflow = 'hidden';
      b.style.position = 'fixed'; b.style.top = -lockY + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
    } else if (!on && locked) {
      locked = false;
      h.style.overflow = ''; b.style.overflow = ''; b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
      window.scrollTo(0, lockY);
    }
  }
  var bought = false;
  function openPop() { if (!pop) return; renderPop(); pop.classList.add('on'); lock(true); ev('domnoM7PopOpen'); }
  function closePop() { if (pop && pop.classList.contains('on')) { pop.classList.remove('on'); lock(false); if (!bought) ev('domnoM7PopClosed'); } }
  function setActive(key) { [].forEach.call(document.querySelectorAll('#bbld .preset'), function (p) { p.classList.toggle('active', p.getAttribute('data-preset') === key); }); }

  function enter() {
    S.active = true; $('bbld').classList.add('myston');
    if (lbl) lbl.innerHTML = 'Your mystery 7 <span>&middot; picked by us</span>';
    setActive('mystery');
    wrap.innerHTML = tiles();
    price();
  }
  function exit() {
    S.active = false; $('bbld').classList.remove('myston'); closePop();
    if (lbl) lbl.innerHTML = lblOrig;
    setActive('');
    restoreFooter(); // the builder's own footer, exactly as it was before Mystery was tapped
  }
  var footSnap = null;
  function snapFooter() {
    var b = $('addBtn');
    footSnap = { w: ($('footWorth') || {}).textContent, p: ($('footPrice') || {}).textContent, s: ($('saveAmt') || {}).textContent, c: ($('cntNum') || {}).textContent, t: b ? b.textContent : '', inc: b ? b.classList.contains('incomplete') : true };
  }
  function restoreFooter() {
    if (!footSnap) return;
    var b = $('addBtn');
    if ($('footWorth')) $('footWorth').textContent = footSnap.w;
    if ($('footPrice')) $('footPrice').textContent = footSnap.p;
    if ($('saveAmt')) $('saveAmt').textContent = footSnap.s;
    if ($('cntNum')) $('cntNum').textContent = footSnap.c;
    if (b) { b.textContent = footSnap.t; b.classList.toggle('incomplete', footSnap.inc); }
  }
  var QSVG = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 500"><rect width="400" height="500" fill="#111"/><polygon points="250,0 330,0 400,70 400,150" fill="#d0021b"/><text x="200" y="300" text-anchor="middle" font-family="Montserrat,Arial,sans-serif" font-weight="900" font-style="italic" font-size="220" fill="#fff">?</text></svg>');
  function buy() {
    if (!ready()) { S.tried = true; ev('domnoM7BuyNotReady'); renderPop(); return; }
    var metalLabel = { silver: 'Silver', gold: 'Gold', mix: 'Mix' }[S.metal] || 'Silver';
    var ref = 'm' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var items = KIND.map(function (k, i) {
      return { id: 'selected_bundle_item_mystery_' + i + '_' + Date.now(), variantId: String(MYSTERY_VARIANT), quantity: '1',
        imgSrc: QSVG, imgAlt: 'Mystery item', description: '<b>Mystery item</b><br>Picked by us' };
    });
    try {
      localStorage.setItem(MKEY, JSON.stringify({ size: S.size, extra: S.two ? S.extra.slice().sort(function (a, b) { return parseFloat(a) - parseFloat(b); }) : [], metal: metalLabel, ref: ref, ts: Date.now() }));
      localStorage.setItem(LSKEY, JSON.stringify(items));
    } catch (e) { toast('Something went wrong, please try again'); return; }
    bought = true;
    ev('domnoM7AddMystery');
    ev({ Silver: 'domnoM7MetalSilver', Gold: 'domnoM7MetalGold', Mix: 'domnoM7MetalMix' }[metalLabel]);
    if (S.two && S.extra.length) ev('domnoM7RangeSizes');
    saveMode('mystery');
    closePop();
    location.href = '/products/7-piece-jewellery-bundle-addon';
  }

  function onPopClick(e) {
    if (e.target === pop || (e.target.getAttribute && e.target.getAttribute('data-x'))) { closePop(); return; }
    var b = e.target.closest ? e.target.closest('button') : null; if (!b) return;
    if (b.hasAttribute('data-sz')) { ev('domnoM7Size'); S.size = b.getAttribute('data-sz'); var dup = S.extra.indexOf(S.size); if (dup > -1) S.extra.splice(dup, 1); }
    else if (b.hasAttribute('data-sz2')) {
      var z = b.getAttribute('data-sz2'), at = S.extra.indexOf(z);
      if (at > -1) S.extra.splice(at, 1);
      else if (S.extra.length < 3) S.extra.push(z);
      else { S.extra.shift(); S.extra.push(z); }            // a 4th tap swaps out the oldest pick
    }
    else if (b.hasAttribute('data-mt')) { S.metal = b.getAttribute('data-mt'); }
    else {
      var a = b.getAttribute('data-my');
      if (a === 'two') { S.two = true; ev('domnoM7RangeOpen'); }
      else if (a === 'one') { S.two = false; S.extra = []; }
      else if (a === 'guide') { ev('domnoM7Guide'); var g = $('szGuideLink'); if (g) g.click(); return; }
      else if (a === 'buy') { buy(); return; }
      else return;
    }
    renderPop(); price();
  }

  /* ---------- the upsell page, for a mystery bundle ---------- */
  function addonPage() {
    /* how this bundle was built, onto the cart (hidden from the customer: starts with _) */
    var bm = null;
    try { bm = JSON.parse(localStorage.getItem(BMKEY) || 'null'); } catch (e) {}
    if (bm && bm.mode && Date.now() - (bm.ts || 0) < 6 * 3600e3) {
      ev('domnoM7Addon');
      if (!TEST && !preview) {
        try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _bundle_mode: bm.mode } }) }).catch(function () {}); } catch (e) {}
      }
    }
    var m = null;
    try { m = JSON.parse(localStorage.getItem(MKEY) || 'null'); } catch (e) {}
    if (!m || !m.size || Date.now() - (m.ts || 0) > 6 * 3600e3) return;   // not a mystery visit: page works as normal
    // only if the saved bundle really is the mystery one (they may have gone back and built their own)
    try { var it = JSON.parse(localStorage.getItem(LSKEY) || '[]'); if (!it.length || String(it[0].variantId) !== String(MYSTERY_VARIANT)) return; } catch (e) { return; }
    ev('domnoM7AddonMystery');
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[name="add"], #no_thanks, button[name="add_upsell"]') : null;
      if (!b) return;
      // the page has other "Add" buttons for single products - only take over the bundle's own one
      if (b.name === 'add') { var fm = b.closest('form'); if (!fm || !fm.querySelector('.bundle_products_inputs')) return; }
      e.preventDefault(); e.stopImmediatePropagation();
      if (b.getAttribute('aria-disabled') === 'true') return;
      var up = null;
      if (b.name === 'add_upsell') { var f = b.closest('.js-product-form'), i = f && f.querySelector('input[name="id"]'); up = i && i.value; }
      var props = { 'Ring size': m.size };
      if (m.extra && m.extra.length) props['Other ring sizes'] = m.extra.join(', ');
      props['Metal'] = m.metal; props['_mystery_ref'] = m.ref;
      var items = [{ id: MYSTERY_VARIANT, quantity: 1, properties: props }];
      if (up) items.push({ id: +up, quantity: 1 });
      ev('domnoM7AddonMysteryTap'); if (up) ev('domnoM7AddonMysteryBox');
      b.setAttribute('aria-disabled', 'true'); b.classList.add('is-loading');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          ev('domnoM7CartMystery');
          try { localStorage.removeItem(MKEY); localStorage.removeItem(LSKEY); localStorage.removeItem(BMKEY); } catch (er) {}
          b.removeAttribute('aria-disabled'); b.classList.remove('is-loading');
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        })
        .catch(function (err) {
          ev('domnoM7CartFail');
          b.removeAttribute('aria-disabled'); b.classList.remove('is-loading');
          var msg = document.createElement('div'); msg.className = 'bundle-error-message'; msg.style.cssText = 'color:#d0021b;margin-top:10px';
          msg.textContent = 'Could not add your mystery bundle. ' + ((err && (err.description || err.message)) || 'Please try again.');
          b.insertAdjacentElement('afterend', msg); setTimeout(function () { msg.remove(); }, 4000);
        });
    }, true);
  }

  /* ---------- boot ---------- */
  function boot() {
    var bb = $('bbld'), sh = document.querySelector('#bbld .preset[data-preset="shuffle"]'), stack = $('stack');
    if (!bb || !sh || !stack) return false;
    loadCat(); readPrices(); SIZES = ringSizes();
    var fl = document.createElement('link'); fl.rel = 'stylesheet'; fl.href = 'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,900&display=swap'; document.head.appendChild(fl);
    var st = document.createElement('style'); st.id = 'domno-mystery-css'; st.textContent = CSS; document.head.appendChild(st);
    sh.setAttribute('data-preset', 'mystery'); sh.innerHTML = '<span class="my-shine"></span><span class="my-lbl"><span class="my-qm">?</span>Mystery<i class="my-new">NEW</i></span>';
    lbl = document.querySelector('#bbld .yb-head .lbl'); lblOrig = lbl ? lbl.innerHTML : '';
    wrap = document.createElement('div'); wrap.id = 'myst';
    stack.parentNode.insertBefore(wrap, stack.nextSibling);
    wrap.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-my="go"]')) openPop(); });
    pop = document.createElement('div'); pop.className = 'my-popbk';
    pop.innerHTML = '<div class="my-pop" role="dialog" aria-label="' + C[3] + '"><div class="my-pophd"><b>' + C[3] + '</b><span data-x="1" aria-label="Close">&times;</span></div>' +
      '<div class="my-popsub">' + C[4] + '</div>' +
      '<div class="my-popbody"></div><div class="my-popfoot"></div></div>';
    document.body.appendChild(pop); // outside #bbld: the builder resets padding/margin on every #bbld child
    pop.addEventListener('click', onPopClick);

    // Listening on the document in the capture phase means this runs before ANY of the
    // builder's own click handlers, on every browser (iOS Safari included).
    document.addEventListener('click', function (e) {
      var p = e.target.closest ? e.target.closest('#bbld #presets .preset') : null; if (!p) return;
      var key = p.getAttribute('data-preset');
      if (key === 'mystery') { e.stopImmediatePropagation(); e.preventDefault(); if (!S.active) { snapFooter(); enter(); } return; }
      if (S.active) exit(); // let the builder handle Pick my own / Best Sellers as normal
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('#bbld #addBtn')) return;
      if (!S.active) { try { localStorage.removeItem(MKEY); } catch (er) {} return; }   // a normal bundle: forget any old mystery choice
      e.stopImmediatePropagation(); e.preventDefault(); openPop();
    }, true);

    return true;
  }
  function startMystery() {
    if (!boot()) {
      var tries = 0, t = setInterval(function () { if (boot() || ++tries > 40) clearInterval(t); }, 150);
    }
  }

  /* ---------- go ---------- */
  if (ON_ADDON) {
    // the add-on page needs no flag: it only acts when a mystery choice was saved on the bundle page
    // runs straight away: the click take-over must be in place before anyone can press a button
    ARM = window.DOMNO_MYSTERY === true ? 'mystery' : window.DOMNO_MYSTERY === false ? 'control' : 'none';
    addonPage();
    return;
  }
  // Intelligems is deferred: wait up to 8 s for the flag before deciding
  var waited = 0;
  (function wait() {
    var f = window.DOMNO_MYSTERY;
    if (preview || typeof f === 'boolean' || ++waited > 40) {
      ARM = preview || f === true ? 'mystery' : f === false ? 'control' : 'none';
      if (ARM === 'mystery' && preview && /[?&]view=bundle3\b/.test(location.search) && location.pathname.indexOf('/collections/') === -1) {
        location.replace(location.pathname.replace('/products/', '/collections/all/products/') + '?view=bundle2&dp=mystery');
        return;
      }
      var tb = 0; (function tw() { if (document.getElementById('bbld')) trackBundlePage(); else if (++tb < 50) setTimeout(tw, 150); })();
      if (ARM === 'mystery') startMystery();
    } else setTimeout(wait, 200);
  })();
})();
